<template>   
  <div class="col-md-12">
    <barra-navegacao :visiblebutton="true"/>
    <b-row class="text-center">
        <b-col cols="12">          
          <div style="margin-bottom:10px"></div>
             <b-col lg="12" class="my-1">
              <b-form-group
                label="Pesquisar"
                label-for="filter-input"
                label-cols-sm="3"
                label-align-sm="right"
                label-size="sm"
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    id="filter-input"
                    v-model="filter"
                    type="search"
                    placeholder="Login do Usuário"
                  ></b-form-input>

                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <div style="margin: 10px"></div>
              <b-card bg-variant="light" style="min-height: 60vh;">
                <div class="col-md-12">                   
                    <div class="overflow-auto">
                      <b-table stacked="md" id="table-usuarios" @filtered="onFiltered" :filter="filter" :filter-included-fields="filterOn" striped small :fields="fields" :items="usuarios" responsive="sm" :per-page="perPage" :current-page="currentPage">
                        
                        <template v-slot:cell(status)="data">
                           <b-badge :variant="data.item.status === 'A' ? 'success' : 'danger'">
                             {{ data.item.status === 'A' ? 'Ativo' : 'Inativo' }}
                            
                           </b-badge>
                        </template>

                        <template v-slot:cell(perfis)="data">
                           <b-badge v-for="p in data.item.perfis" :key="p.idPerfil" variant="info" style="margin-right: 2px;">{{ p.nomePerfil }}</b-badge>
                        </template>

                      </b-table>
                      <div style="float: right">
                        <b-pagination
                        size="sm"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="table-usuarios"
                        ></b-pagination>
                      </div>                      
                    </div>
                </div>
              </b-card>
        </b-col>
      </b-row>
    </div>
</template>

<script>
import BarraNavegacao from '../../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },

  data(){
    return{
      usuarios: [],
      fields: [
        { key: 'idUsuario', label: 'ID', class:'text-center', sortable: true },
        { key: 'usuario', label: 'Login' , class:'text-center', sortable: true },
        { key: 'perfis', label: 'Perfis' , class:'text-center' },
        { key: 'status', label: 'Status' , class:'text-center' }
      ],
      perPage: 10,
      currentPage: 1,
      rows: 0,
      filter: null,
      filterOn: ['usuario'],
    }
  },

  created(){
    this.listarUsuarios();
  },

  methods: {
    alertaMensager(mensagem, titulo, tipo){
          this.$fire({
              title: titulo,
              text: mensagem,
              type: tipo,
          });
    },

    listarUsuarios(){
      this.$http.get("/usuario").then(res => {
         this.usuarios = res.data;
         console.log(this.usuarios);
         this.rows = this.usuarios.length;
      }).catch(() => {
         this.alertaMensager("Erro ao carregar usuários.", "Erro", "error");
      });
    },

    onFiltered(filteredItems) {
      this.rows = filteredItems.length;
      this.currentPage = 1;
    }
  }
}
</script>

<style>

</style>
